const colors = {
  gray: {
    300: '#e1e1e6',
    600: '#29292e',
    700: '#202024',
    800: '#121214',
  },
  purple: {
    500: '#8257e5',
  },
  black: {
    400: '#0e0f13',
  },
  primary: {
    100: '#E5FCF1',
    200: '#27EF96',
    300: '#10DE82',
    400: '#0EBE6F',
    500: '#0CA25F',
    600: '#0A864F',
    700: '#086F42',
    800: '#075C37',
    900: '#064C2E',
  },
};

export default colors;
